import Restapi from "../api/Restapi";
import {REPORTING_URL, constats} from "../constant"


export const GetAllHospitalByCity = async (cityid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/hospitals/city/'+cityid,null);
}

export const GetAllHospitalByCities = async (cityid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('post',REPORTING_URL+'/apiv1/hospitals/cities',cityid);
}

export const AddUserHospitalData = async (userid,hospitalid,hospitalclassid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    let data = JSON.stringify({
        "userid":userid,
        "hospitalid":hospitalid,
        "classid":hospitalclassid, 
        "status":"ACTIVE"
    });
    return await Restapi('post',REPORTING_URL+'/apiv1/userhospital',data);
}

export const UpdateUserHospitalStatus = async (id,status) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    
    return await Restapi('put',REPORTING_URL+`/apiv1/userhospital/update/${id}/${status}`,null);
}

export const DeleteUserhospitalStatus = async (id) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('delete',REPORTING_URL+'/apiv1/userhospital/'+id,null);
}

export const CreateUserHospitalData = async (userid,areas,hospitalname,address,countryid,stateid,cityid,pincode,phone,email) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    var arr = [areas];
    let data = JSON.stringify({
        "userid":userid,
        "status":"PENDING_FOR_ADDITION",
        "areas":arr,
        "hospitalname":hospitalname,
        "address":address,
        "countryid":countryid,
        "stateid":stateid,
        "cityid":cityid,
        "pincode":pincode,
        "phone":phone,
        "email":email,
        "createdby":userid
    });
    return await Restapi('post',REPORTING_URL+'/apiv1/userhospital/create',data);
}

export const GetAllHospitalbyUserStatus = async (user,status) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/userhospital/status/'+user+'/'+status,null);
}